/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Processing_Queue_StatusInputs */



/**
* | output |
* | --- |
* | "Processing Event Queue..." |
*
* @param {Render_Audio_Processing_Queue_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_processing_queue_status = /** @type {((inputs?: Render_Audio_Processing_Queue_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Processing_Queue_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement de la file d'attente des evenements...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitung der Ereigniswarteschlange...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione coda eventi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка очереди событий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesando cola de eventos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在处理事件队列...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント キューを処理中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट क्यू को प्रोसेस किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processando fila de eventos...")
	return /** @type {LocalizedString} */ ("Processing Event Queue...")
});